<div *ngIf="isLoading" class="loading-overlay">
  <div class="spinner"></div>
</div>
